export default __webpack_public_path__ + "static/media/tzLogo.10a4acde.png";